import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {ResourceService} from "../../../services/resource.service";

@Component({
  selector: 'app-my-account-admin',
  templateUrl: './my-account-admin.component.html',
  styleUrls: ['./my-account-admin.component.css']
})
export class MyAccountAdminComponent implements OnInit {

  constructor(private resourceService: ResourceService, private router:Router, private toastr: ToastrService) {
  }

  ngOnInit() {
    this.checkSession();
  }

  checkSession(){
    if(!localStorage.getItem('token')){
      this.router.navigate(["/admpro/user"])
    }
  }

}
